<gala-filtre (display)="showFiltre($event)" />

<div class="filtre" [hidden]="boFiltreHide">
    <ul>
        <li> {{lgTradFiltre.FILTRE}} </li>
        <li>
            <select-filtre #select [options]="filtreAppli" (selected)="filtrer()"
                placeholder="{{ lgTradFiltre.APPLICATIF }}" optSorted="ASC" />
        </li>
    </ul>
    <div class="total">{{ translate.instant("FILTERS.TOTAL") }}<span>{{ getListeFiltree()?.length || 0 }}</span>
    </div>
</div>

<div>
    <div class="d-flex justify-content-center">
        <table class="table table-striped col-md-8">
            <thead>
                <tr>
                    @for (head of headElements; track head) {
                    <th (click)="sortBy(head.tri)" [ngClass]="(head.sortable)?'cursor-hand':'cursor-arrow'">
                        {{head.libelle}}&nbsp;@if (head.sortable) {
                        <cp-icon-sort [col]="sColTri === head.tri" [boo]=booAscendant />
                        }
                    </th>
                    }
                    <th></th>
                </tr>
            </thead>
            <tbody>
                @for (profil of listeElementsAff; track profil) {
                <tr>
                    <td>{{ profil.NOMAPP }}</td>
                    <td>{{ profil.PROFIL }}</td>
                    <td class="text-right col-btngroup">
                        <div class="btn-group">
                            @if (profil.NOMAPP !== 'ECLAT') {
                            @if (droitsAccess.write) {
                            <gala-btn-edit (click)="onEditProfilListe(profil.IDAPPLICATIF,profil.IDPROFIL)" />
                            } @else {
                            <gala-btn-search (click)="onEditProfilListe(profil.IDAPPLICATIF,profil.IDPROFIL)" />
                            }
                            }
                            @if (droitsAccess.write && profil.NBUTIL === 0) {
                            <gala-btn-delete (click)="onDeleteProfilListe(profil.IDAPPLICATIF,profil.IDPROFIL)" />
                            }
                        </div>
                    </td>
                </tr>
                }
            </tbody>
        </table>
    </div>
    <paginator />
</div>